import { Box } from '@mui/material'
import * as React from 'react'

import { DeskFormProps } from '../../types/ComponentProps'

import DeskFormFields from './DeskFormFields'
import FormMessages from './FormMessages'
import FormSubmitButton from './FormSubmitButton'

/**
 * DeskForm - Presentation component for desk creation/editing form
 * Focuses only on form rendering and validation display
 */
export default function DeskForm({
  formData,
  isEditMode,
  isSubmitting,
  availableOffices,
  validationErrors,
  successMessage,
  onSubmit,
  onChange,
  onClearMessage,
  preSelectedOffice,
  onCancel
}: DeskFormProps) {
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    onSubmit(formData)
  }

  return (
    <Box component='form' noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
      <FormMessages
        validationErrors={validationErrors}
        successMessage={successMessage}
        onClearMessage={onClearMessage}
      />

      <DeskFormFields
        formData={formData}
        isEditMode={isEditMode}
        availableOffices={availableOffices}
        onChange={onChange}
        preSelectedOffice={preSelectedOffice}
      />

      <FormSubmitButton
        isEditMode={isEditMode}
        isSubmitting={isSubmitting}
        onCancel={onCancel}
      />
    </Box>
  )
}
